<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData">
    <el-form-item class="item" label="工厂：" prop="factoryCode">
      <el-input  v-model="fromData.searchCriteria.codeOrDesc" clearable :placeholder="$store.state.remark.factory"></el-input>
    </el-form-item>   
  </search-box>
  </el-form>
</template>


<script>
import searchBox from 'components/common/search.vue';
export default{
  components:{
    searchBox
  },
  props:{
    fromData:Object,
    MaterialType:Array,
    MaterialGroup:Array
  },
  data(){
    return{
      rules: {
        factoryCode:[{message: "",trigger: "blur"}],
        factoryDesc:[{message: '',trigger: 'change'}]
      }
    }
  },
  methods:{
    //搜索
    subSearch(){
      this.$emit('subSearch');
    },
    getMaterialGroup(val){
      let obj = this.MaterialGroup.find(v=>v.materialGroupDesc === val);
      if(obj){
        this.fromData.searchCriteria.materialGroupDesc = val;
        this.fromData.searchCriteria.materialGroupId= obj.materialGroupId;
      }
    },
    getMaterialType(val){
      let obj = this.MaterialType.find(v=>v.materialTypeName === val);
      if(obj){
        this.fromData.searchCriteria.materialTypeName = val;
        this.fromData.searchCriteria.materialTypeId= obj.materialTypeId;
      }
    }
  }
}
</script>

<style>
</style>
